import { render, staticRenderFns } from "./BillingDO.vue?vue&type=template&id=18874f93"
import script from "./BillingDO.vue?vue&type=script&lang=js"
export * from "./BillingDO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports